<template></template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, onBeforeMount } from 'vue';
import type { IntegrationEspBrazeModel } from './Model';
import { getQueryParams } from '@/src/utilities/Url';
import { useCampaignStore } from '@/src/store/campaign';

export default defineComponent({
  name: 'integration-esp-braze',
  props: {
    model: {
      type: Object as PropType<IntegrationEspBrazeModel>,
      required: true
    }
  },
  setup() {
    const campaignStore = useCampaignStore();

    onBeforeMount(async () => {
      const params = getQueryParams();

      if (params.EID) {
        campaignStore.addStaticFormData({
          eid: params.EID
        });
      }
    });
  }
});
</script>
